/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settingsnav_Workspacegroup2Inputs */

const zh_settingsnav_workspacegroup2 = /** @type {(inputs: Settingsnav_Workspacegroup2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工作区`)
};

const en_settingsnav_workspacegroup2 = /** @type {(inputs: Settingsnav_Workspacegroup2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workspace`)
};

const es_settingsnav_workspacegroup2 = /** @type {(inputs: Settingsnav_Workspacegroup2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espacio de trabajo`)
};

/**
* | output |
* | --- |
* | "Workspace" |
*
* @param {Settingsnav_Workspacegroup2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const settingsnav_workspacegroup2 = /** @type {((inputs?: Settingsnav_Workspacegroup2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingsnav_Workspacegroup2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_settingsnav_workspacegroup2(inputs)
	if (locale === "en") return en_settingsnav_workspacegroup2(inputs)
	return es_settingsnav_workspacegroup2(inputs)
});
export { settingsnav_workspacegroup2 as "settingsNav_workspaceGroup" }